import AbstractNode from './AbstractNode';

export default class TableCell extends AbstractNode {
    get name() {
        return "table_cell";
    }

    get markdownToken() {
        return "td";
    }

    get schema() {
        return {
            content: "block+",
            attrs: {
                colspan: {default: 1},
                rowspan: {default: 1},
                color: {default: 'white'},
                aligned: {default: 'left'},
            },
            tableRole: "cell",
            isolating: true,
            parseDOM: [{
                tag: "td", getAttrs: dom => ({
                    colspan: Number(dom.getAttribute("colspan") || 1),
                    rowspan: Number(dom.getAttribute("rowspan") || 1),
                    color: dom.getAttribute("data-color"),
                    aligned: dom.getAttribute("data-aligned")
                })
            }],
            toDOM: node => ["td", {
                class: `${node.attrs.color ? `${node.attrs.color}` : ''}${node.attrs.aligned ? ` ${node.attrs.aligned} aligned` : ''}`,
                colspan: node.attrs.colspan,
                rowspan: node.attrs.rowspan,
                'data-color': node.attrs.color,
                'data-aligned': node.attrs.aligned,
            }, 0]
        }
    }

    toMarkdown(state, node) {
        const {colspan, rowspan} = node.attrs;
        state.ensureNewLine();
        state.write(`<td class="${node.attrs.color ? node.attrs.color : ''}${node.attrs.aligned ? ` ${node.attrs.aligned} aligned` : ''}" ${colspan > 1 ? ` colspan="${colspan}"` : ''}${rowspan > 1 ? ` rowspan="${rowspan}"` : ''}${node.attrs.color ? ` data-color="${node.attrs.color}"` : ''}${node.attrs.aligned ? ` data-aligned="${node.attrs.aligned}"` : ''}>`);
        state.write('\n\n');
        state.renderContent(node);
        state.write('</td>');
        state.ensureNewLine();
    }

    get parseMarkdown() {
        return {
            block: "table_cell", getAttrs: token => ({
                colspan: Number(token.attrGet("colspan") || 1),
                rowspan: Number(token.attrGet("rowspan") || 1),
                color: token.attrGet("data-color"),
                aligned: token.attrGet("data-aligned")
            })
        }
    }
}